<template>
  <div id="AppSelectStaff" style="height:350px;">
    <!-- 担当者選択 -->
    <div class="columns is-vcentered">
      <!-- 営業所選択 -->
      <div class="control column" style="min-height:350px;">
        <b-table
          :data="officeMaster"
          :selected.sync="selectedOffice"
          v-on:select="officeSelected"
          focusable
          class="tableStyle"
        >
          <template slot-scope="props">
            <b-table-column field="officeCode">
              {{ props.row.officeName }}
            </b-table-column>
          </template>
        </b-table>
      </div>

      <!-- 担当者選択 -->
      <div class="control column" style="min-height:350px;">
        <b-table
          :data="filteredStaffList"
          :selected.sync="selectedStaff"
          v-on:select="staffSelected"
          focusable
          class="tableStyle"
        >
          <template slot-scope="props">
            <b-table-column field="staff">
              {{ props.row.lastName + props.row.firstName }}
              <span v-if="props.row.staffCode">
                ({{ props.row.staffCode }})
              </span>
            </b-table-column>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppSelectStaff",
  props: ["officeCode", "officeMasterList", "selected"],
  methods: {
    getStaff: function() {
      return this.selectedStaff;
    },
    back: function(event) {},
    staffSelected: function() {
      this.$emit("input", true);
    },
    officeSelected: function(office) {
      this.selectedStaff = {};
      this.selectedOfficeCode = office.officeCode;

      //call Web API
      var excuteApi = this.getUserListPOST;
      var successCallBack = this.getUserListSuccess;
      var errorCallBack = this.getUserListError;
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getUserListPOST: function(client) {
      return client.apis.apiMaster.getUserListPOST({
        body: {
          officeCode: this.selectedOfficeCode
        }
      });
    },
    getUserListSuccess: function(result) {
      this.filteredStaffList = result.obj;
    },
    getUserListError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    }
  },
  data() {
    var officeMaster = [];
    // Listがなければ
    if (this.$props.officeMasterList == undefined) {
      officeMaster = JSON.parse(sessionStorage.getItem("officeMaster"));
      var specifiedOfficeCode = this.$props.officeCode;
      if (specifiedOfficeCode != undefined) {
        officeMaster = officeMaster.filter(function(value) {
          return value.officeCode == specifiedOfficeCode;
        });
      }
    } else {
      officeMaster = this.$props.officeMasterList;
    }
    return {
      officeMaster,
      staffList: [],
      filteredStaffList: [],
      selectedOfficeCode: "",
      selectedStaff: {},
      selectedOffice: {},
      specifiedOfficeCode
    };
  },
  mounted: function() {}
};
</script>
<style lang="scss" scoped>
  .tableStyle {
    border:solid 1px;
    border-color:lightgrey;
    width: 350px;
    height:300px;
    overflow-y:scroll;
  }
</style>



// WEBPACK FOOTER //
// src/components/AppSelectStaff.vue